(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ap-city-backdrop"] && !Shopify.designMode) return;
  try {
    
function placeAngryPenguinBackdrop() {
  const scene = document.querySelector('.ap-city-scene');
  if (scene && scene.parentElement !== document.body) document.body.prepend(scene);
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', placeAngryPenguinBackdrop, { once: true });
} else {
  placeAngryPenguinBackdrop();
}
document.addEventListener('shopify:section:load', placeAngryPenguinBackdrop);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ap-shop-nav"] && !Shopify.designMode) return;
  try {
    
function setAngryPenguinActiveLinks() {
  const current = window.location.pathname.replace(/\/$/, '') || '/';
  document.querySelectorAll('a[href*="/collections/"], .ap-shop-nav a').forEach(link => {
    const url = new URL(link.href, window.location.origin);
    const path = url.pathname.replace(/\/$/, '') || '/';
    if (url.origin === window.location.origin && path === current && !url.hash) {
      link.classList.add('ap-category-active');
      link.setAttribute('aria-current', 'page');
    }
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setAngryPenguinActiveLinks, {once:true});
else setAngryPenguinActiveLinks();
document.addEventListener('click', event => {
  const link = event.target.closest('.ap-shop-nav a, .menu-drawer a');
  if (!link) return;
  document.querySelectorAll('.ap-link-selected').forEach(item => item.classList.remove('ap-link-selected'));
  link.classList.add('ap-link-selected');
});
document.addEventListener('shopify:section:load', setAngryPenguinActiveLinks);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ap-waddle-community"] && !Shopify.designMode) return;
  try {
    
function revealWaddleSignup(scrollToForm) {
  const panel = document.getElementById('join-the-waddle');
  if (!panel) return;
  panel.hidden = false;
  if (scrollToForm) panel.scrollIntoView({behavior:'auto',block:'start'});
}
function checkWaddleSignup() {
  const panel = document.getElementById('join-the-waddle');
  if (!panel) return;
  if (window.location.hash === '#join-the-waddle' || panel.querySelector('.ap-signup-success, .ap-signup-errors')) {
    revealWaddleSignup(true);
  }
}
document.addEventListener('click', event => {
  const link = event.target.closest('a[href]');
  if (!link) return;
  const url = new URL(link.href, window.location.origin);
  if (url.origin === window.location.origin && url.pathname === window.location.pathname && url.hash === '#join-the-waddle') {
    revealWaddleSignup(false);
  }
});
window.addEventListener('hashchange', checkWaddleSignup);
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', checkWaddleSignup, {once:true});
else checkWaddleSignup();
document.addEventListener('shopify:section:load', checkWaddleSignup);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
